<template>
  <div
    class="group relative flex cursor-pointer flex-col overflow-hidden"
    :class="[color && color + '-container']"
  >
    <div class="mb-1 flex w-full flex-row justify-between">
      <h3 class="text-title-large mb-1">{{ data.skill.title }}</h3>
      <BaseIcon>chevron_right</BaseIcon>
    </div>
    <HistogramChart
      :scale="scale"
      :perspectives="data.perspectives"
      :all-perspectives="topicPerspectives"
      :show-self-feedback="showSelfFeedback"
    />

    <BaseStateLayer />
  </div>
</template>
<script lang="ts" setup>
  import { computed } from 'vue'
  import type { Scale } from '@/core/models/scale'
  import type { SkillAnalysis } from '@/core/models/surveys-analytics'
  import type { Perspective } from '@/core/models/perspective'
  import BaseIcon from '../../base/icon/BaseIcon.vue'
  import BaseStateLayer from '../../base/state-layer/BaseStateLayer.vue'
  import HistogramChart from './HistogramChart.vue'

  interface Props {
    scale: Scale
    data: SkillAnalysis
    topicPerspectives: ReadonlyArray<Perspective>
    /** When true, self is drawn as a bar series. Defaults to false. */
    showSelfFeedback?: boolean
  }

  const props = withDefaults(defineProps<Props>(), {
    showSelfFeedback: false,
  })

  const color = computed(() => {
    return props.data.skill.color
  })
</script>
